// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textOperator[data-v-167b11fa] {\n  color: #00a551;\n  cursor: pointer;\n  font-size: 22px;\n}\n.textOperator1[data-v-167b11fa] {\n  color: #f56c6c;\n  cursor: pointer;\n  font-size: 22px;\n}", ""]);
// Exports
module.exports = exports;
